<!--
 * @Author: M.D.
 * @Date: 2019-12-24 14:25:15
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 * 商品评价
 -->
<template>
  <div class="gds-comments-o-w">
    <div class="gds-cmt-default-info" v-if="commentList.length === 0">
      <img class="gds-ep-pic" :src="require('@/assets/image/empty_comment.png')" alt="">
      <span class="gds-ep-text">暂无用户评价</span>
    </div>
    <ul class="gds-comments-ul" v-if="commentList.length !== 0">
      <li v-for="(i, index) in bodyComment" :key="index" class="gds-cmt-i">
        <div class="gds-cmt-i-l">
          <div class="cmt-img">
            <el-avatar size="medium">
              <img :src="tImgUrl(i.image)" :onerror="errImgDefault"/>
            </el-avatar>
          </div>
          <div class="gds-cmt-usr-name">{{i.commenter}}</div>
        </div>
        <div class="gds-cmt-i-r">
          <div class="gds-cmt-d-top">
            <div>{{i.commentTime}}</div>
            <el-rate class="gds-cmt-rate" v-model="i.grade" disabled></el-rate>
          </div>
          <div class="gds-cmt-ctx">{{i.comment}}</div>
          <div class="gds-cmt-img" v-if="i.image">
            <el-image
            :key="im"
            v-for="im in disImg(i.image)"
            style="width: 100px; height: 100px; margin-right: 10px"
            :src="tImgUrl(im)"
            :preview-src-list="cmtImg(i.image)"
            fit="cover">
            </el-image>
          </div>
        </div>
      </li>
    </ul>

<!-- 分页 -->
    <div class="gds-l-g-page-w"  v-if="commentList.length !== 0">
      <el-pagination
        class="gds-l-g-page"
        background
        @current-change="pageChg"
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import API from '@/api/api'
export default {
  props: ['prdId'],
  data () {
    return {
      rate: 5,
      pageSize: 8,
      total: 0,
      currentPage: 1,
      comShow: false,
      commentList: [],
      lastCommentId: ''
    }
  },
  computed: {
    bodyComment () {
      // return this.commentList
      return this.commentList
    }
  },
  created () {
    this.getComments()
  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    pageChg (v) {
      this.currentPage = v
      this.getComments()
      window.scrollTo(0, 500)
    },
    allComments () {
      this.comShow = true
    },
    async getComments () {
      const Cre = await API.getComments({
        goodsId: this.prdId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (Cre.data.statusCode === '200') {
        this.commentList = Cre.data.result.records
        this.total = Number(Cre.data.result.total || 0)
        this.currentPage = Number(Cre.data.result.current || 1)
        if (this.commentList.length) {
          this.lastCommentId = this.commentList[this.commentList.length - 1].id
          this.commentList.forEach(item => {
            item.rate = 4
          })
        }
      } else {
        this.$message({
          message: Cre.data.message,
          type: 'error'
        })
      }
    },
    async moreComments () {
      const Cre = await API.getComments({
        goodsId: this.prdId,
        commentId: this.lastCommentId
      })
      if (Cre.data.statusCode === '200') {
        this.commentList = this.commentList.concat(Cre.data.result)
        if (this.commentList.length) {
          this.lastCommentId = this.commentList[this.commentList.length - 1].id
        }
      } else {
        this.$message({
          message: Cre.data.message,
          type: 'error'
        })
      }
    },
    disImg (imageStrs) {
      let images = imageStrs.split(',')
      let array = []
      for (let img of images) {
        if (img && img !== '') {
          array.push(img)
        }
      }
      return array
    },
    cmtImg (imageStrs) {
      let images = imageStrs.split(',')
      let array = []
      for (let img of images) {
        if (img && img !== '') {
          array.push(this.tImgUrl(img))
        }
      }
      return array
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.el-dialog__wrapper
    .el-dialog
      overflow: hidden
      .el-dialog__body
        max-height: 450px
        overflow hidden
        .infinite-list
          .infinite-list-item
            display flex
            min-height 120px
            border-bottom 1px solid btn-dis-font-cl
            margin-bottom 10px
            .gds-cmt-i-l-a
              flex 0 0 100px
              margin-right 20px
              .cmt-img-a
                flex-top()
                margin 10px 0
              .gds-cmt-usr-name-a
                color #666666
                font-size 12px
                text-align center
            .gds-cmt-i-r-a
              flex 1 1 auto
              padding 6px 10px 0px
              .gds-cmt-d-top-a
                color #999999
                font-size 12px
              .gds-cmt-ctx-a
                word-break break-all
                color #555555
                font-size 18px
                margin 16px 0
              .gds-cmt-img-a
                flex 1 1 100px
                flex-direction row
.gds-comments-o-w
  .gds-cmt-default-info
    text-align  center
    min-height 250px
    background-color white
    display flex
    flex-direction column
    justify-content center
    align-items center
    .gds-ep-text
      color #999999
      font-size 13px
  .gds-l-g-page-w
    padding 10px
    text-align right
  .gds-comments-ul
    .gds-cmt-i
      display flex
      padding-bottom 10px
      min-height 120px
      border-bottom 1px solid btn-dis-font-cl
      margin-bottom 10px
      .gds-cmt-i-l
        flex 0 0 100px
        margin-right 20px
        .cmt-img
          flex-top()
          margin 10px 0
        .gds-cmt-usr-name
          color #666666
          font-size 12px
          text-align center
      .gds-cmt-i-r
        flex 1 1 auto
        padding 6px 10px 0px
        .gds-cmt-d-top
          color #999999
          font-size 12px
          display flex
          flex-direction row
          justify-content space-between
          align-items center
          box-sizing border-box
          vertical-align middle
          .gds-cmt-rate
            float right
            display inline-block
        .gds-cmt-ctx
          word-break break-all
          color #555555
          font-size 18px
          margin 16px 0
        .gds-cmt-img
          flex 1 1 100px
          flex-direction row
</style>
